import { render } from "./LanguageDropdown.vue?vue&type=template&id=00681bcf&scoped=true"
import script from "./LanguageDropdown.vue?vue&type=script&lang=js"
export * from "./LanguageDropdown.vue?vue&type=script&lang=js"

import "./LanguageDropdown.vue?vue&type=style&index=0&id=00681bcf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00681bcf"]])

export default __exports__